/**
 * Portal detay → ppLaunchPortalDetailProQuery bağlamı.
 */

/**
 * @param {object | null | undefined} summary
 * @param {number} snapshotId
 * @returns {object}
 */
export function buildPortalProQueryLauncherContext(summary, snapshotId) {
  if (!summary || typeof summary !== 'object') {
    return { snapshotId };
  }

  const props = summary.properties && typeof summary.properties === 'object'
    ? summary.properties
    : {};

  return {
    snapshotId,
    ada: summary.ada,
    parsel: summary.parsel,
    query_type: summary.query_type,
    parcel_coords_lonlat: summary.parcel_coords_lonlat,
    city_name: summary.city_name,
    town_name: summary.town_name,
    quarter_name: summary.quarter_name,
    tkgm_value: summary.tkgm_value,
    proparcel_value: summary.proparcel_value,
    area_m2: summary.arazi_m2 ?? summary.area_m2 ?? null,
    nitelik: props.nitelik ?? props.Nitelik ?? summary.nitelik ?? '',
    properties: {
      ...props,
      ilAd: props.ilAd || summary.city_name || '',
      ilceAd: props.ilceAd || summary.town_name || '',
      mahalleAd: props.mahalleAd || summary.quarter_name || '',
      mahalleId: props.mahalleId ?? props.mahalle_id ?? summary.tkgm_value ?? null,
      adaNo: props.adaNo ?? summary.ada,
      parselNo: props.parselNo ?? summary.parsel,
      ada: props.ada ?? summary.ada,
      parsel: props.parsel ?? summary.parsel,
      nitelik: props.nitelik ?? props.Nitelik ?? summary.nitelik ?? '',
    },
  };
}

/**
 * @param {object} context
 * @returns {Promise<void>}
 */
export async function launchPortalDetailProQueryFromSummary(context) {
  if (typeof window.ppLaunchPortalDetailProQuery !== 'function') {
    throw new Error('Pro sorgu başlatıcı yüklenemedi. Sayfayı yenileyin.');
  }
  await window.ppLaunchPortalDetailProQuery(context);
}
